'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate() {
}
export { $c_Lapp_api_UnauthenticatedAppUpdate as $c_Lapp_api_UnauthenticatedAppUpdate };
$c_Lapp_api_UnauthenticatedAppUpdate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_UnauthenticatedAppUpdate.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate as $h_Lapp_api_UnauthenticatedAppUpdate };
$h_Lapp_api_UnauthenticatedAppUpdate.prototype = $c_Lapp_api_UnauthenticatedAppUpdate.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_api_UnauthenticatedAppUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_UnauthenticatedAppUpdate)));
}
export { $isArrayOf_Lapp_api_UnauthenticatedAppUpdate as $isArrayOf_Lapp_api_UnauthenticatedAppUpdate };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update.js.map
